import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=22988419&"
import script from "../js/customerInfo.js?vue&type=script&lang=js&"
export * from "../js/customerInfo.js?vue&type=script&lang=js&"
import style0 from "../css/common.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports